import { render, staticRenderFns } from "./InputWeight.vue?vue&type=template&id=ec44e0aa&"
import script from "./InputWeight.vue?vue&type=script&lang=js&"
export * from "./InputWeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports